import { BackgroundColors } from "@utils/getBackgroundColor";
import React from "react";
import { twMerge } from "tailwind-merge";

const Triangle = ({
  className,
  manualColor,
  autoColor,
}: {
  className?: string;
  manualColor?: string;
  autoColor?: BackgroundColors;
}) => {
  const getBackground = () => {
    switch (autoColor) {
      case "teal":
        return "border-b-primary";
      case "dark_teal":
        return "border-b-primary-dark";
      case "salmon":
        return "border-b-salmon";
      case "pale_yellow":
        return "border-b-paleYellow";
      case "navy":
        return "border-b-navy";
      case "light_blue":
        return "border-b-lightBlue";
      case "white":
        return "border-b-white";
      case "abyss":
        return "border-b-abyss";
      case "terracotta":
        return "border-b-terracotta";
      case "off_white":
        return "border-b-offWhite";
      case "egg_yolk":
        return "border-b-eggYolk";
      case "misty_rose":
        return "border-b-mistyRose";
      case "mint_mist":
        return "border-b-mintMist";
      case "light_gray":
        return "border-b-lightGray";
      case "olive":
        return "bg-olive";
    }
  };

  const triangleClasses = twMerge(
    "scale-y-[-1] border-b-[50px] md:border-b-[78px] lg:border-b-[135px] absolute -translate-y-[0.0001em]",
    className,
    getBackground()
  );
  const triangleStyles = {
    borderLeft: "min(72.5vw, 1376px) solid transparent",
    borderRight: "min(27.5vw, 575px) solid transparent",
    borderBottomColor: manualColor,
  };

  return <div className={triangleClasses} style={triangleStyles} />;
};

export default Triangle;
